import { Token } from "./token";
export class BracketManager {

    /** Keeps track of the brackets as we go along. Its totally not a stack really but its kinda close enough */
    private stack = "";
    private allowedCharacters = ["(", ")", "[", "]"];
    private errors: string[] = [];

    /** Push a bracket onto the pseudo-stack. Return true if there's a bracketing error, false otherwise
     */
    public push(token: Token): boolean {
        if (token.isTransient) {
            return;
        }

        const bracket = token.value;
        if (!this.allowedCharacters.find((c) => c === bracket)) {
            throw new Error("Stack error, attempting to push a non-bracket character onto the bracket stack");
        }
        const length = this.stack.length;
        const lastChar = length ? this.stack.substring(length - 1, length) : "";

        switch (bracket) {
            case "(":
            case "[":
                this.stack = this.stack + bracket;
                break;
            case ")":
                if (lastChar === "(") {
                    this.stack = this.stack.substring(0, length - 1);
                } else {
                    this.errors.push(`The opening and closing brackets in your search do not match`);
                    return true;
                }
                break;
            case "]":
                if (lastChar === "[") {
                    this.stack = this.stack.substring(0, length - 1);
                } else {
                    this.errors.push(`The opening and closing brackets in your search do not match`);
                    return true;
                }
                break;
            default:
                throw new Error("Stack error, attempting to push a non-bracket character onto the bracket stack");
        }

        return false;
    }
    /** Returns the number of outstanding brackets */
    public get Errors(): string {
        if (this.errors[0]) {
            return this.errors[0];
        }
        if (this.stack.length > 0) {
            return "The opening and closing brackets in your search do not match";
        }
        return "";
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/helpers/search-tree/bracket-manager.ts